module.exports = __webpack_public_path__ + "static/Boat-Final-compressed-a5d046670ccd75d39c790a954fe0c4fd.mp4";